import { Heart } from "lucide-react";

import { Link } from "react-router";

import { useT } from "@/lib/i18n";

const GROUP_URL = "https://www.bsafegroup.be/";

export function PoweredBy({ className }: { className?: string }) {
  const t = useT();
  const [before, after] = t("app.madeIn").split("{heart}");

  return (
    <p className={className}>
      <a
        className="transition-colors hover:text-ink hover:underline"
        href={GROUP_URL}
        rel="noreferrer"
        target="_blank"
      >
        {t("app.poweredBy")}
      </a>
      <span aria-hidden> · </span>
      <Link className="transition-colors hover:text-ink hover:underline" to="/privacy">
        {t("nav.privacy")}
      </Link>
      <span aria-hidden> · </span>
      <span className="inline-flex items-center gap-1">
        {before}
        <Heart aria-hidden className="h-3 w-3 fill-danger text-danger" />
        {after}
      </span>
    </p>
  );
}
